<div class="main-container">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <h1>Change Your Password</h1>
        <p class="light">Please create a new password for your account.</p>
        <p class="light">Your password should be made up of uppercase, lowercase letters and numbers (no symbols please).</p>
        <br>
        <form class="login">
          <div class="field">
            <div class="label">New Password</div>
            <app-text-input
              icon="lock"
              type="password"
              v-model="password"
              placeholder="Enter your new password"
              :error="validation('password')"
              autocomplete="new-password"
            />
          </div>

          <div class="field">
            <div class="label">Confirm New Password</div>
            <app-text-input
              icon="lock"
              type="password"
              v-model="confirmPassword"
              placeholder="Confirm your new password"
              :error="validation('confirm_password')"
              autocomplete="new-password"
            />
          </div>

          <div class="field">
            <a class="ui fluid primary button" v-on:click="reset()">CHANGE PASSWORD</a>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
